import { getAuthHeaders, getBaseUrl } from './apiClient';

// Canonical course skill taxonomy (Category / Skill / Subskill). Source of truth
// for course skill_focus selection; the generation pipeline validates against the
// same framework. Served from GET /secure/courses/skill-framework.
export type SkillFrameworkSkill = { skill: string; subskills: string[] };
export type SkillFrameworkCategory = { category: string; skills: SkillFrameworkSkill[] };
export type SkillFramework = { version?: string; categories: SkillFrameworkCategory[] };

// A single course skill-focus selection. custom=true is a free-text escape hatch
// for skills not in the framework.
export type SkillFocus = { category: string; skill: string; custom?: boolean };

// A skill tag on a lesson/exercise: structured {category, skill, subskill, custom}.
// Legacy data may still be a plain string, so renderers accept both.
export type SkillTag =
  | string
  | { category?: string; skill?: string; subskill?: string; custom?: boolean };

// Render a skill tag as a readable label, tolerant of legacy string tags.
export function skillTagLabel(tag: SkillTag): string {
  if (typeof tag === 'string') return tag;
  if (tag && typeof tag === 'object') {
    return [tag.category, tag.skill, tag.subskill].filter(Boolean).join(' / ');
  }
  return tag == null ? '' : String(tag);
}

export const skillFrameworkService = {
  async get(): Promise<SkillFramework> {
    const resp = await fetch(`${getBaseUrl()}/secure/courses/skill-framework`, {
      headers: await getAuthHeaders(),
    });
    if (!resp.ok) throw new Error(`Failed to load skill framework (${resp.status})`);
    return resp.json();
  },
};
